import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Popover, MenuItem } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import Iconify from 'src/components/iconify';

import { checkDelete } from '../../../services/user.service';

export default function OptionsPopover({
  open,
  handleCloseMenu,
  setModifyUserModal,
  selectedRow,
  removeUser,
  showDelete,
  unarchive,
  onEditPermissions,
  userCapabilities,
}) {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const { canUpdateUser, canDeleteUser, canManagePermissions } = userCapabilities;

  const handleDelete = async () => {
    try {
      const isLinked = await checkDelete(selectedRow.id);
      if (isLinked) {
        removeUser(selectedRow.id, true);
      } else {
        removeUser(selectedRow.id);
      }
    } catch (e) {
      console.error(e);
    } finally {
      handleCloseMenu();
    }
  };

  return (
    <Popover
      open={Boolean(open)}
      anchorEl={open}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: isSmallScreen ? 140 : 170,
          '& .MuiMenuItem-root': {
            px: 1.5,
            py: 1,
            typography: 'body2',
            borderRadius: 0.75,
            fontWeight: 600,
          },
        },
      }}
    >
      {canUpdateUser && (
        <MenuItem
          onClick={() => {
            setModifyUserModal(true);
            handleCloseMenu();
          }}
        >
          <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
          {t('popover.edit')}
        </MenuItem>
      )}

      {canManagePermissions && !selectedRow?.archived && (
        <MenuItem
          onClick={() => {
            onEditPermissions(selectedRow);
            handleCloseMenu();
          }}
        >
          <Iconify
            icon="solar:shield-keyhole-bold-duotone"
            sx={{ mr: 2, color: 'primary.main' }}
          />
          {t('popover.editPermissions')}
        </MenuItem>
      )}
      {canDeleteUser && showDelete && !selectedRow?.archived && (
        <MenuItem sx={{ color: 'error.main' }} onClick={handleDelete}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          {t('popover.delete')}
        </MenuItem>
      )}

      {canUpdateUser && selectedRow?.archived && (
        <MenuItem
          sx={{ color: 'success.dark' }}
          onClick={() => {
            unarchive(selectedRow.id);
            handleCloseMenu();
          }}
        >
          <Iconify icon="eva:archive-outline" sx={{ mr: 2 }} />
          {t('popover.unarchive')}
        </MenuItem>
      )}
    </Popover>
  );
}

OptionsPopover.propTypes = {
  open: PropTypes.object,
  handleCloseMenu: PropTypes.func,
  setModifyUserModal: PropTypes.func,
  selectedRow: PropTypes.object,
  removeUser: PropTypes.func,
  showDelete: PropTypes.bool,
  unarchive: PropTypes.func,
  onEditPermissions: PropTypes.func,
  userCapabilities: PropTypes.object.isRequired,
};
